import { render, staticRenderFns } from "./product-template-calculation-modal.vue?vue&type=template&id=45273fd4&scoped=true&"
import script from "./product-template-calculation-modal.vue?vue&type=script&lang=ts&"
export * from "./product-template-calculation-modal.vue?vue&type=script&lang=ts&"
import style0 from "./product-template-calculation-modal.vue?vue&type=style&index=0&id=45273fd4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45273fd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VDialog,VDivider,VForm,VIcon,VRow,VSpacer})
